import React from "react";
import Slider from "rc-slider";

import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

export default class ChooseCounts extends React.PureComponent {
  handleUpdateSlider(step) {
    const { updateConversionGain, updateConversionCost, updateConversionMissed, updateConversionSaved } = this.props;

    if (step === 0) {
      updateConversionGain(1);
      updateConversionSaved(1);
      updateConversionCost(10);
      updateConversionMissed(10);
    } else if (step === 1) {
      updateConversionGain(1);
      updateConversionSaved(1);
      updateConversionCost(5);
      updateConversionMissed(5);
    } else if (step === 2) {
      updateConversionGain(1);
      updateConversionSaved(1);
      updateConversionCost(2);
      updateConversionMissed(2);
    } else if (step === 3) {
      updateConversionGain(1);
      updateConversionSaved(1);
      updateConversionCost(1);
      updateConversionMissed(1);
    } else if (step === 4) {
      updateConversionGain(2);
      updateConversionSaved(2);
      updateConversionCost(1);
      updateConversionMissed(1);
    } else if (step === 5) {
      updateConversionGain(5);
      updateConversionSaved(5);
      updateConversionCost(1);
      updateConversionMissed(1);
    } else if (step === 6) {
      updateConversionGain(10);
      updateConversionSaved(10);
      updateConversionCost(1);
      updateConversionMissed(1);
    }
  }

  calculateStep() {
    const { conversionGain, conversionCost } = this.props;

    let step = 0;

    if (conversionGain === 1 && conversionCost === 10) {
      step = 0;
    } else if (conversionGain === 1 && conversionCost === 5) {
      step = 1;
    } else if (conversionGain === 1 && conversionCost === 2) {
      step = 2;
    } else if (conversionGain === 1 && conversionCost === 1) {
      step = 3;
    } else if (conversionGain === 2 && conversionCost === 1) {
      step = 4;
    } else if (conversionGain === 5 && conversionCost === 1) {
      step = 5;
    } else if (conversionGain === 10 && conversionCost === 1) {
      step = 6;
    }

    return step;
  }

  renderSlider() {
    const { id, isContinuous, options } = this.props;

    const marks = isContinuous
      ? {
          0: "Overestimate > 10x Underestimate",
          1: "Overestimate > 5x Underestimate",
          2: "Overestimate > 2x Underestimate",
          3: "Overestimate = Underestimate",
          4: "Underestimate > 2x Overestimate",
          5: "Underestimate > 5x Overestimate",
          6: "Underestimate > 10x Overestimate"
        }
      : {
          0: "Cost > 10 times Benefit",
          1: "Cost > 5 times Benefit",
          2: "Cost > 2 times Benefit",
          3: "Cost = Benefit",
          4: "Benefit > 2 times Cost",
          5: "Benefit > 5 times Cost",
          6: "Benefit > 10 times Cost"
        };

    const step = this.calculateStep();

    const isLocked = options && options["lock"];

    return (
      <AibleStep
        id={id}
        bId={"rawCostsContinuous"}
        message={
          isContinuous
            ? "Got it. How does the cost of an over prediction compare to the cost of an under prediction?"
            : "Got it. Now please tell me the following: How does the cost of the AI" +
              " making an incorrect prediction compare to the benefit of " +
              "the AI making an accurate prediction?"
        }
        isBreak={true}
      >
        <div className={styles.sliderBody}>
          <div className={styles.sliderLabel}>
            {isContinuous ? "Relative Cost of Overestimate vs Underestimate" : "Cost-Benefit Tradeoff"}
          </div>
          <div className={styles.sliderValue}>{marks[step]}</div>
          <div className={styles.sHolder}>
            <div className={styles.cost} style={{ paddingRight: "10px" }}>
              {isContinuous ? "Over" : "Cost"}
            </div>
            <Slider
              min={0}
              max={6}
              value={step}
              dots={true}
              onChange={isLocked ? () => {} : (val) => this.handleUpdateSlider(val)}
              className={styles.sliderHolder}
            />
            <div className={styles.cost} style={{ paddingLeft: "10px" }}>
              {isContinuous ? "Under" : "Benefit"}
            </div>
          </div>
        </div>
      </AibleStep>
    );
  }

  render() {
    const { isShow } = this.props;

    return (
      <div className={styles.dataBody} style={{ opacity: isShow === true ? 1 : 0 }}>
        {this.renderSlider()}
      </div>
    );
  }
}
